import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const rootEl = document.getElementById("root")!;

// If the static-site-generation step pre-rendered HTML into the root, hydrate
// it (attach event listeners over the existing DOM). Otherwise mount fresh.
// The check `rootEl.hasChildNodes()` distinguishes the two paths cleanly.
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <App />);
} else {
  createRoot(rootEl).render(<App />);
}
